import { render, staticRenderFns } from "./FriabilityTest.vue?vue&type=template&id=70452426&"
import script from "./FriabilityTest.vue?vue&type=script&lang=js&"
export * from "./FriabilityTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports